import { createContext } from "@-/com.npmjs.use-context-selectors";
import { defaultError } from "@-/com.npmjs.react-context-default-error";
import type { MorphemeInfoPanelContextValue } from "#morpheme-info-panel-context-value";

export const MorphemeInfoPanelContext = createContext(
  defaultError<MorphemeInfoPanelContextValue>("MorphemeInfoPanelContext"),
);
